module.exports = __webpack_public_path__ + "img/open-quote.3467215c.svg";